import {getRecognitionAttempts} from './getRecognitionAttempts'
import {getPersonTaggingDiagnostics} from './getPersonTaggingDiagnostics'
import {getTaggingCoverage} from './getTaggingCoverage'

export const faces = {
  getRecognitionAttempts,
  getPersonTaggingDiagnostics,
  getTaggingCoverage,
}
